

























import { defineComponent }            from '@vue/composition-api';
import cButton                        from '@/components/form/button/button.component.vue';
import { GlobalContexts, useGlobals } from '@/hooks/use-globals';
import useGlobalTranslations          from '@/hooks/use-global-translations';
import { getViewStorePath }           from '@/store/store.helpers';
import { name as vLogin }             from '@/views/login/login.route';
import useCookiePolicyHook            from '@/views/cookie-policy/hooks/use-cookie-policy.hook';
import { RouteParams }                from '@/router/router.types';

export default defineComponent({
  name: 'cLoginFooterCookie',
  components: {
    cButton,
  },
  setup() {
    const { i18n, store }: GlobalContexts = useGlobals();
    const buttonAccept = useGlobalTranslations('buttons.accept');
    const { cookiePolicy }: { cookiePolicy: RouteParams } = useCookiePolicyHook();

    const setCookiePolicy = (): void => {
      store.commit(`${getViewStorePath(vLogin)}/setCookiePolicy`, true);
    };

    return {
      i18n,
      cookiePolicy,
      buttonAccept,
      setCookiePolicy,
    };
  },
});
